"use client";

import { c as _c } from "react/compiler-runtime";
import { useT } from "@/lib/i18n";
import { Link } from "@/i18n/navigation";
import { imageUrl } from "@/lib/image-url";
import { noteText, type AncientPool, type GameNames, type PoolRelic } from "./pool-data";
import "./ancients.css";
function RelicPill(t0) {
  const $ = _c(39);
  const {
    relic,
    names,
    bp,
    isPerCharacter
  } = t0;
  const t = useT();
  const relicData = names.relics;
  const info = relicData[relic.id];
  let t1;
  if ($[0] !== info?.name || $[1] !== relic.id) {
    t1 = info?.name || relic.id.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, _temp);
    $[0] = info?.name;
    $[1] = relic.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const name = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] !== bp || $[4] !== info || $[5] !== isPerCharacter || $[6] !== name || $[7] !== names || $[8] !== relic.condition || $[9] !== relic.id || $[10] !== t) {
    const charOrder = ["Ironclad", "Silent", "Defect", "Necrobinder", "Regent"];
    const variants = info?.name_variants ? charOrder.filter(c_0 => info.name_variants && info.name_variants[c_0]).map(c_1 => ({
      char: c_1,
      name: info.name_variants[c_1]
    })) : [];
    t5 = "anc-relic";
    let t7;
    if ($[16] !== relic.id) {
      t7 = relic.id.toLowerCase();
      $[16] = relic.id;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    const t8 = `${bp}/relics/${t7}`;
    let t9;
    if ($[18] !== info || $[19] !== name) {
      t9 = info?.image_url && <img src={imageUrl(info.image_url)} alt={name} crossOrigin="anonymous" />;
      $[18] = info;
      $[19] = name;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    let t10;
    if ($[21] !== name) {
      t10 = <span className="anc-relic-name">{name}</span>;
      $[21] = name;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    if ($[23] !== t10 || $[24] !== t8 || $[25] !== t9) {
      t6 = <Link prefetch={false} href={t8} className="anc-relic-link">{t9}{t10}</Link>;
      $[23] = t10;
      $[24] = t8;
      $[25] = t9;
      $[26] = t6;
    } else {
      t6 = $[26];
    }
    t2 = "anc-relic-meta";
    if ($[27] !== names || $[28] !== relic.condition || $[29] !== t) {
      t3 = relic.condition && <span className="anc-cond">{noteText(relic.condition, t, names)}</span>;
      $[27] = names;
      $[28] = relic.condition;
      $[29] = t;
      $[30] = t3;
    } else {
      t3 = $[30];
    }
    t4 = isPerCharacter && variants.length > 0 && <span className="anc-variants"><span className="lbl">{t("Shows as 5 separate options:")}</span>{" "}{variants.map((v, i) => <span key={v.char}><span className="vn">{v.name}</span><span> ({t(v.char)})</span>{i < variants.length - 1 ? ", " : ""}</span>)}</span>;
    $[3] = bp;
    $[4] = info;
    $[5] = isPerCharacter;
    $[6] = name;
    $[7] = names;
    $[8] = relic.condition;
    $[9] = relic.id;
    $[10] = t;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
  }
  let t7;
  if ($[31] !== t2 || $[32] !== t3 || $[33] !== t4) {
    t7 = <div className={t2}>{t3}{t4}</div>;
    $[31] = t2;
    $[32] = t3;
    $[33] = t4;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  let t8;
  if ($[35] !== t5 || $[36] !== t6 || $[37] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  return t8;
}
function _temp(c) {
  return c.toUpperCase();
}
export function AncientPools(t0) {
  const $ = _c(13);
  const {
    ancient,
    names,
    bp
  } = t0;
  const t = useT();
  let t1;
  if ($[0] !== ancient.per_character_relics || $[1] !== ancient.pools || $[2] !== bp || $[3] !== names || $[4] !== t) {
    let t2;
    if ($[6] !== ancient.per_character_relics || $[7] !== bp || $[8] !== names || $[9] !== t) {
      t2 = (pool, i) => <div key={i} className="anc-pool"><div className="anc-pool-h"><span>{noteText(pool.name, t, names)}</span><span className="cnt">{pool.relics.length}{" "}{pool.relics.length === 1 ? t("relic") : t("relics")}</span></div>{pool.description && <p className="anc-pool-desc">{noteText(pool.description, t, names)}</p>}<div className="anc-relics">{pool.relics.map(relic => <RelicPill key={relic.id} relic={relic} names={names} bp={bp} isPerCharacter={!!ancient.per_character_relics?.includes(relic.id)} />)}</div></div>;
      $[6] = ancient.per_character_relics;
      $[7] = bp;
      $[8] = names;
      $[9] = t;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t1 = ancient.pools.map(t2);
    $[0] = ancient.per_character_relics;
    $[1] = ancient.pools;
    $[2] = bp;
    $[3] = names;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[11] !== t1) {
    t2 = <div className="anc-pools">{t1}</div>;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}